var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import tariffs from './assets/data/tariffs.json';
;
(function () {
    var _a;
    const expand = document.querySelectorAll('[data-expand]');
    const accordions = document.querySelectorAll('[data-accordion]');
    const navButton = document.getElementById('nav-button');
    const navMenu = document.getElementById('nav-menu');
    const navClose = document.getElementById('nav-close');
    // const recipientSelector = document.getElementById('recipient-selector');
    const tariffForm = document.getElementById('tariff-form');
    const asGiftForm = document.getElementById('as-gift-form');
    const avatarUploader = document.getElementById('uploader');
    const avatarImg = document.getElementById('avatar-img');
    const backLink = document.querySelector('.back-link');
    const tabs = document.querySelectorAll(".chat-tabs li");
    const panels = document.querySelectorAll(".chat-window");
    if (tabs === null || tabs === void 0 ? void 0 : tabs.length) {
        tabs.forEach(tab => {
            tab.addEventListener("click", e => {
                e.preventDefault();
                // снять active со всех табов и панелей
                tabs.forEach(t => t.classList.remove("active"));
                panels.forEach(p => p.classList.remove("active"));
                // добавить active выбранному табу
                tab.classList.add("active");
                // найти id панели
                const selector = tab.dataset.tab;
                if (selector) {
                    const panel = document.querySelector(selector);
                    panel === null || panel === void 0 ? void 0 : panel.classList.add("active");
                }
            });
        });
    }
    window.addEventListener("pageshow", () => {
        if (navMenu) {
            navMenu.classList.remove('animate');
            navMenu.classList.remove('open');
            setTimeout(() => {
                navMenu.classList.add('animate');
            }, 300);
        }
    });
    backLink === null || backLink === void 0 ? void 0 : backLink.addEventListener('click', e => {
        e.preventDefault();
        if (document.referrer !== '') {
            history.back();
        }
        else {
            window.location.href = '/';
        }
        return false;
    });
    (_a = avatarUploader === null || avatarUploader === void 0 ? void 0 : avatarUploader.querySelector('fieldset')) === null || _a === void 0 ? void 0 : _a.addEventListener('change', (e) => {
        var _a;
        if (avatarImg && ((_a = e.target) === null || _a === void 0 ? void 0 : _a.value))
            avatarImg.src = e.target.value;
    });
    setTimeout(() => {
        navMenu === null || navMenu === void 0 ? void 0 : navMenu.classList.add('animate');
    }, 100);
    navButton === null || navButton === void 0 ? void 0 : navButton.addEventListener('click', () => {
        navMenu === null || navMenu === void 0 ? void 0 : navMenu.classList.add('open');
    });
    navClose === null || navClose === void 0 ? void 0 : navClose.addEventListener('click', () => {
        navMenu === null || navMenu === void 0 ? void 0 : navMenu.classList.remove('open');
    });
    accordions.forEach(el => {
        el.addEventListener('click', () => {
            el.classList.toggle('open');
        });
    });
    expand.forEach(el => {
        const btn = el.querySelector('button');
        btn === null || btn === void 0 ? void 0 : btn.addEventListener('click', () => {
            el.classList.add('open');
        });
    });
    if (tariffForm) {
        tariffForm.addEventListener('change', (e) => {
            var _a;
            if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.name) === 'purpose' && e.target.value === 'as-gift') {
                asGiftForm === null || asGiftForm === void 0 ? void 0 : asGiftForm.classList.add('show');
            }
            else {
                asGiftForm === null || asGiftForm === void 0 ? void 0 : asGiftForm.classList.remove('show');
            }
        });
    }
    const sharedAudio = document.getElementById('shared-audio');
    let currentMsg = null;
    const rafMap = new Map();
    document.querySelectorAll('.voice-message').forEach((msg) => {
        const btn = msg.querySelector('.play-button');
        const progressEl = msg.querySelector('.progress');
        const track = msg.querySelector('.waveform');
        const audioSrc = msg.dataset.audio;
        if (!btn || !progressEl || !audioSrc || !track)
            return;
        const updateProgress = () => {
            // if (!sharedAudio.duration || isNaN(sharedAudio.duration)) return;
            const percent = (sharedAudio.currentTime / sharedAudio.duration) * 100;
            progressEl.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
            const rafId = requestAnimationFrame(updateProgress);
            rafMap.set(msg, rafId);
        };
        const stopAnimation = (target) => {
            const id = rafMap.get(target);
            if (id !== undefined)
                cancelAnimationFrame(id);
            const el = target.querySelector('.progress');
            const button = target.querySelector('.play-button');
            if (el)
                el.style.clipPath = 'inset(0 100% 0 0)';
            button === null || button === void 0 ? void 0 : button.classList.remove('pause');
        };
        track.addEventListener('click', (e) => {
            const rect = progressEl.getBoundingClientRect();
            const clickX = e.clientX - rect.left;
            const percent = clickX / rect.width;
            if (!isNaN(sharedAudio.duration)) {
                sharedAudio.currentTime = percent * sharedAudio.duration;
                const newPercent = (sharedAudio.currentTime / sharedAudio.duration) * 100;
                progressEl.style.clipPath = `inset(0 ${100 - newPercent}% 0 0)`;
            }
        });
        btn.addEventListener('click', () => {
            const isSame = currentMsg === msg;
            const isPlaying = !sharedAudio.paused;
            // Если нажали на уже играющее сообщение — ставим на паузу
            if (isSame && isPlaying) {
                sharedAudio.pause();
                btn === null || btn === void 0 ? void 0 : btn.classList.remove('pause');
                cancelAnimationFrame(rafMap.get(msg));
                return;
            }
            // Если другое сообщение — остановить предыдущее
            if (currentMsg && !isSame) {
                stopAnimation(currentMsg);
            }
            // Если новое или было на паузе — воспроизвести
            const absoluteAudioSrc = new URL(audioSrc, location.href).href;
            if (sharedAudio.src !== absoluteAudioSrc) {
                sharedAudio.src = audioSrc;
            }
            sharedAudio.play();
            btn === null || btn === void 0 ? void 0 : btn.classList.add('pause');
            currentMsg = msg;
            updateProgress();
        });
        sharedAudio.addEventListener('ended', () => {
            if (currentMsg === msg) {
                stopAnimation(msg);
            }
        });
    });
    // console.log(expand);
})();
;
(function () {
    return __awaiter(this, void 0, void 0, function* () {
        const mappingCountry = {
            "KZ": "kzt",
            "RU": "rub",
            "US": "usd",
            "DE": "eur",
            "FR": "eur"
        };
        const symbols = {
            rub: "₽",
            kzt: "₸",
            usd: "$",
            eur: "€",
        };
        const select = document.querySelector(".select_form");
        const prices = document.querySelectorAll(".price");
        if (select) {
            let currency = yield detectCurrency();
            if (!currency) {
                const lang = navigator.language.toLowerCase(); // например "en-US"
                if (lang.startsWith("en")) {
                    currency = "usd";
                }
            }
            select.addEventListener("change", () => {
                updatePrices(select.value);
            });
            // запуск при загрузке (дефолтная валюта из select)
            if (currency && ["rub", "kzt", "usd", "eur"].includes(currency)) {
                select.value = currency; // выставляем валюту в селекторе
                updatePrices(currency); // обновляем цены
            }
            else {
                updatePrices(select.value);
            }
        }
        // обработчик смены валюты
        function updatePrices(currency) {
            prices.forEach(priceEl => {
                const tariffName = priceEl.dataset['name'];
                const value = tariffs[tariffName][currency];
                if (value) {
                    priceEl.textContent = `${value}${symbols[currency]}`;
                }
            });
        }
        function detectCurrency() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const res = yield fetch("https://get.geojs.io/v1/ip/geo.json");
                    const data = yield res.json();
                    return mappingCountry[data.country_code];
                }
                catch (e) {
                    console.error("Ошибка при получении региона:", e);
                    return null;
                }
            });
        }
    });
})();
